export default __webpack_public_path__ + "static/media/ISSO CLASS-10 EXAM PATTERN 2025.30302b3f.pdf";